<template>
  <div :class="$style.container">
    <payment-template>
      <base-header
        :title="$t('safe.deal.title')"
        :language="language"
        slot="header"
      />

      <div slot="content">
        <deal-information
          :deal-status="deal.status"
          :payment-data="payment"
        />

        <div :class="$style.deal">
          <div :class="$style.title">
            <h2>{{ $t('deal.dispute.title') }}</h2>
          </div>

          <div :class="$style.dispute">
            <open-dispute-form @submit="handleOpenDispute" />
          </div>

          <div :class="$style.redirect">
            <simple-button variant="secondary" @click="handleRedirect">
              {{ $t('deal.button.redirect') }}
            </simple-button>
          </div>

          <div
            v-html="$t('deal.privacy.policy', { link: getPolicyPrivacy })"
            :class="$style.privacy"
          ></div>
        </div>
      </div>

      <base-footer slot="footer" />
    </payment-template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import HTTPService from 'services/Http';

import SimpleButton from 'molecules/common/SimpleButton';
import BaseFooter from 'molecules/base/BaseFooter';
import BaseHeader from 'organisms/base/BaseHeader';
import PaymentTemplate from 'templates/PaymentTemplate';

import DealInformation from './components/DealInformation';
import OpenDisputeForm from './components/OpenDisputeForm';

export default {
  name: 'OpenedSafeDeal',
  components: {
    SimpleButton,
    BaseFooter,
    BaseHeader,
    PaymentTemplate,
    OpenDisputeForm,
    DealInformation,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
      required: true,
    },
    payment: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['getPolicyPrivacy']),
  },
  methods: {
    async handleOpenDispute(payload) {
      try {
        await HTTPService.dealDispute({
          deal: {
            ...this.deal,
            dispute: payload,
          },
        });

        this.$emit('update');
      } catch (error) {
        console.error(error);
      }
    },
    handleRedirect() {
      window.location.assign(this.project.url);
    },
  },
};
</script>

<style lang="sass" module>
  .conatiner
    +respond-to('medium')
      padding: 10px 0

  .deal
    margin-top: 40px

  .dispute
    margin-bottom: 10px

  .redirect
    margin-bottom: 20px

  .title
    margin-bottom: 20px
    padding: 10px 0
    background-image: url('@/assets/svg/custom/opened-dispute.svg')
    background-repeat: no-repeat
    background-position: right

    h2
      margin: 0
      font-weight: 600
      font-size: 16px
      line-height: 25px
      color: rgba(33, 33, 33, 1)

      +respond-to('medium')
        font-size: 18px

  .privacy
    +small-text
    color: rgba(33, 33, 33, 1)

    a
      display: inline
      word-break: break-word
</style>
